// extracted by mini-css-extract-plugin
export default {"listPrice":"ListsPrice_listPrice__h-D5l","listsPriceButton":"ListsPrice_listsPriceButton__rMNxB"};